// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeedingTable_wrapper__dwfhn","guide":"FeedingTable_guide__ZTVYK","table":"FeedingTable_table__1nzD_"};